import { useEffect, useReducer, useRef, useState } from "react";
import PropTypes from 'prop-types';
import userReducer, { initialStateUser } from "./UserReducer";
import SocketApi from "../../services/socket-fdd";
import { GlobalContext } from "./GlobalContext";
import { TYPES } from "../../../config/constants/typesReducers";
import AuthService from "../../services/auth-service";

export const GlobalProvider = ({children}) => {
    const socketRef = useRef(new SocketApi());
    const [state, dispatch] = useReducer(userReducer, initialStateUser);
    const [authLoading, setAuthLoading] = useState(true);

    // Cargar usuario desde localStorage al iniciar la app
    useEffect(() => {
        const loadUserFromStorage = () => {
            const user = AuthService.getCurrentUser();
            const token = localStorage.getItem('authToken');
            
            if (user && token) {
                // Dispatch LOGIN con los datos del usuario
                dispatch({
                    type: TYPES.AUTHENTICATION.LOGIN,
                    payload: user
                });
            }
            
            // Marcar que terminó de cargar
            setAuthLoading(false);
        };
        
        loadUserFromStorage();
    }, []);

    // Detectar sesión expirada desde cualquier llamada a la API
    useEffect(() => {
        const handleSessionExpired = () => {
            dispatch({ type: TYPES.AUTHENTICATION.LOGOUT });
        };
        window.addEventListener('auth:session-expired', handleSessionExpired);
        return () => window.removeEventListener('auth:session-expired', handleSessionExpired);
    }, []);

    useEffect(() => {
        const currentSocket = socketRef.current;
        currentSocket.connect();
        return () => currentSocket.disconnect();
    }, [socketRef]);

    return(
        <GlobalContext.Provider value={{
            userState: state,
            userDispatch: dispatch,
            socketRef,
            authLoading
        }}>
            {children}
        </GlobalContext.Provider>
    )
}

GlobalProvider.propTypes = {
    children: PropTypes.node.isRequired
}